import { jsx } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { AnalyticsId } from "./constants.js";
import spacerStyles from "./components/Spacer/styles.module.scss";
const Spacer = React__default.forwardRef(function SpacerForwardedRef(props, ref) {
  const { size = "s", className, testId } = props;
  const spacerClasses = classNames(
    spacerStyles.spacer,
    {
      [spacerStyles["spacer--4xs"]]: size === "4xs",
      [spacerStyles["spacer--3xs"]]: size === "3xs",
      [spacerStyles["spacer--2xs"]]: size === "2xs",
      [spacerStyles["spacer--xs"]]: size === "xs",
      [spacerStyles["spacer--s"]]: size === "s",
      [spacerStyles["spacer--m"]]: size === "m",
      [spacerStyles["spacer--l"]]: size === "l",
      [spacerStyles["spacer--xl"]]: size === "xl",
      [spacerStyles["spacer--2xl"]]: size === "2xl",
      [spacerStyles["spacer--3xl"]]: size === "3xl",
      [spacerStyles["spacer--4xl"]]: size === "4xl",
      [spacerStyles["spacer--5xl"]]: size === "5xl",
      [spacerStyles["spacer--6xl"]]: size === "6xl"
    },
    className
  );
  return /* @__PURE__ */ jsx("span", { className: spacerClasses, ref, "data-testid": testId, "data-analyticsid": AnalyticsId.Spacer });
});
export {
  Spacer as S
};
//# sourceMappingURL=Spacer.js.map
